<template>
  <button
    :class="[$style.container, $style[variant]]"
    @click="$emit('navigate')"
  >
    <slot name="default">
      <arrow-left-icon v-fill:white />
    </slot>
  </button>
</template>

<script>
import { inArray } from 'lib/component/validators';

import ArrowLeftIcon from 'atoms/icons/arrows/ArrowLeft';

export default {
  name: 'NavigateButton',
  components: {
    ArrowLeftIcon,
  },
  props: {
    variant: {
      type: String,
      validator: inArray([
        'primary',
        'secondary',
      ]),
      default: () => 'primary',
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +size(60px)
    +flexbox
    +justify-content(center)
    +align-items(center)
    border-radius: var(--border-radius-circle)

    &.primary
      background-color: var(--color-dark-blue)
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15)

      &:hover,
      &:active,
      &:focus
        background-color: var(--color-green)
</style>
